module.exports = __webpack_public_path__ + "img/aer-logo-top.a673e212.png";